//
export default [
    'wh_item',
    'wh_product_upc_code',
    //'wh_product_global_stocks'
]